import { render, staticRenderFns } from "./Satisfaction.vue?vue&type=template&id=106fad7c&"
import script from "./Satisfaction.vue?vue&type=script&lang=js&"
export * from "./Satisfaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports